import React from "react";
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";


const RegAccountVerificationSuccessScreen = () => {

  return (
    <div className="gcotg-userhome-top-level">
      <Container fluid className="no-padding">
        <div className="gcotg-simple-screen">
          <h2 className="gcotg-generic-title">Verification Successful</h2>
          <p>
            Thank you for verifying your gift card claims account. You may now log in.
          </p>
          <Link to="/registeredlogin" className="btn btn-primary gcotg-button">
            Login
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default RegAccountVerificationSuccessScreen;
